import { useEffect, useState } from "react";
import Modalstructure from "../../../components/structure";
import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import StyledInput from "../../../../styledInput/StyledInput";
import SelectPhone from "../../../../phone/SelectPhone";
import Button from "../../../../button";
import SubmitButton from "../../../../button/SubmitButton";
import ApiDatabase from "../../../../../server";

// Reusable creation modal : called from Employees page and Mission flows.
// Caller controls open/close via `isOpen` and gets the new worker through `onCreated`.
const ModalCreateWorker = ({ isOpen, onClose, onCreated }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setFirstname("");
      setLastname("");
      setPhone("");
      setError("");
      setSubmitting(false);
    }
  }, [isOpen]);

  const canSubmit =
    firstname.trim().length > 0 && lastname.trim().length > 0 && (phone || "").trim().length > 0;

  const handleSubmit = () => {
    if (!canSubmit) return;
    setSubmitting(true);
    setError("");
    ApiDatabase.postCreateWorker(
      {
        firstname: firstname.trim(),
        lastname: lastname.trim(),
        phone,
      },
      (data) => {
        setSubmitting(false);
        onCreated?.(data?.worker || null);
      },
      (err) => {
        setSubmitting(false);
        setError(
          err?.response?.data?.message ||
            "Impossible de créer cet employé. Vérifiez les informations saisies."
        );
      }
    );
  };

  return (
    <Modalstructure isShowing={isOpen}>
      <Modalheader hide={onClose} hideShow>
        Ajouter un employé
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-2 gap-4">
            <StyledInput
              type="text"
              label="Prénom"
              placeholder="Prénom"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
            />
            <StyledInput
              type="text"
              label="Nom"
              placeholder="Nom"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
            />
          </div>
          <label>
            <div className="ft-sm font-medium text-gray-500">
              Numéro de téléphone
            </div>
            <SelectPhone phoneValue={phone} setPhoneValue={setPhone} />
          </label>
          {error ? <div className="ft-sm text-red-600">{error}</div> : null}
        </div>
      </ModalBody>
      <ModalFooter>
        <>
          <Button color="SECONDARY" size="LG" onClick={onClose}>
            Annuler
          </Button>
          <SubmitButton
            loading={submitting}
            disabled={!canSubmit}
            onClick={handleSubmit}
          />
        </>
      </ModalFooter>
    </Modalstructure>
  );
};

export default ModalCreateWorker;
